export function getModels() {
  const token = localStorage.getItem("token");
  const headers = new Headers({ 
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json"
  });
  return fetch(`${process.env.REACT_APP_API_BASE}/models/`, {
    headers,
  })
    .then(r => {
      if (!r.ok) throw new Error("Unable to fetch models.");
      return r.json();
    });
}
